import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/ajmer.jpg";
import Newsletter from "../../shared/Newsletter";
import { Helmet } from 'react-helmet';
const Ajmer = () => {
  return (
    <>
      <Helmet>
        <title>Ajmer, Rajasthan | The Rustic Paths</title>

        <meta charset="UTF-8" />

        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <meta
          name="description"
          content="Explore the historic city of Ajmer in Rajasthan, India with The Rustic Paths. Immerse yourself in the cultural richness, visit sacred sites, and experience the serenity of Ajmer. Plan your journey with our private driver services and discover the unique blend of spirituality and history in Ajmer."
        />
        <meta
          name="keywords"
          content="Ajmer, Rajasthan, about ajmer city, private driver, The Rustic Paths, ajmer tourist places, ajmer places to visit, cultural richness, sacred sites, spirituality, history"
        />
        <meta name="author" content="The Rustic Paths" />


        <link rel="icon" href="path_to_your_favicon.ico" type="image/x-icon" />
      </Helmet>
      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">Ajmer</h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Dargah Sharif</li>
                      <li>Adhai-din-ka-Jhonpra</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Ajmer
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    Raja Ajay Pal Chauhan built the city of Ajmer in the seventh
                    Century. Till the 12th Century, this city remained the main
                    center of the Chauhan dynasty. Thereafter, the city was
                    taken over by Mohammed Ghauri. Afterwards, Ajmer served as
                    the abode of the Mughal emperors also. Later, the Scindias
                    ruled over the city in the 19th Century, before handing it
                    over to the British. Read on this Ajmer City Guide to
                    further explore this holy city.
                  </p>
                  <p>
                    The city of Ajmer Sharif in Rajasthan, India lies to the
                    south west of Jaipur. Ajmer travel & tourism is mostly
                    famous as a pilgrimage. Both Hindus as well as Muslims look
                    upon this city with great reverence. The most famous pilgrim
                    center in the city is the Dargah (memorial) of the great
                    Sufi saint Khwaja Moin-ud-din Chisti. He came from Persia
                    and spent his whole life to improve the lives of the
                    destitute and downtrodden communities.
                  </p>

                  <p>
                    Another thing the city is famous for is its esteemed and
                    highly impressive Mayo College, exclusively for boys. The
                    school was set up by the British, during their rule over
                    India. Other attractions of the city include the massive
                    Taragarh Fort, Adhai-Din Ka Jhonpra (an old mosque built in
                    2.5 days only), the picturesque Ana Sagar Lake, etc. Ajmer
                    also serves as the station for those visiting Pushkar
                    housing the only temple of Lord Brahma in India. In brief,
                    we can say that Ajmer is a city rich in culture and
                    tradition.
                  </p>

                  <p>
                    Through the great vision and scholarly skills of Maharaja
                    Sawai Jai Singh II and extensive works by his Chief
                    Architect Vidyadhar Bhattacharji, Jaipur rose to fame as the
                    most beautiful and the best planned place to live in.
                    Liberal, protective and secular policies of the rulers
                    attracted a wide range of artisans, artists and businessmen,
                    which today make this city, a great arts, crafts, trade and
                    cultural centre. Architecturally, the city proved to be a
                    milestone and other great kings like Sawai Ram Singh and
                    Sawai Mansingh II added many more public buildings and
                    institutions to this existing masterpiece.
                  </p>

                  <p>
                    Ajmer Sightseeing includes its fort and other monuments that
                    are quite famous throughout the state of Rajasthan. They are
                    examples of the magnificent architecture for which the state
                    of Rajasthan is renowned throughout the world. Apart from
                    that, there are a number of other places to visit in Ajmer.
                    Some of the prime tourist attractions of Ajmer include
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Dargah Sharif
                  </h2>

                  <p>
                    Ajmer is venerated as a holy place for both Hindus and
                    Muslims. It has the mausoleum of the Sufi saint, Khwaja
                    Moinuddin Chishti, whose blessings are eagerly sought by
                    pilgrims to his dargah. Known as the 'Dargah Sharif', the
                    last resting place of the saint who died in 1235 lies at the
                    foot of a barren hill. The saint's marble domed mausoleum is
                    India's most important shrine for Muslims and receives an
                    endless flow of visitors of all religions as the sick, the
                    troubled and the childless come here seeking a boon, a
                    blessing or just peace of mind. Legend has it that the
                    Mughal emperor, Akbar came here to the saint in the 16th
                    century in quest of a boon for an heir and the saint
                    obliged.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Adhai-din-ka-Jhonpra
                  </h2>
                  <p>
                    Located beyond the Dargah, on the outskirts of the town are
                    the ruins of this mosque. According to legend, its
                    construction in 1153 took 2 days (adhai din), hence the
                    name. It was originally a Sanskrit college, built within a
                    temple. But In 1193 AD Mohamed Ghouri seized Ajmer and
                    converted the building into a mosque by adding a
                    seven-arched wall in front of the pillared hall. The
                    building is a fine piece of Indo-Islamic architecture. The
                    pillars are all different and the arched screen with its
                    minarets is noteworthy. Mohhamed Ghauri conquered Ajmer and
                    converted the building into a mosque by adding a sevenarched
                    wall in front of the pillared hall in just two-and-half
                    days(adhai-din) and hence the name.
                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Ajmer;
